<template>
  <!-- <ValidationObserver ref="cmpadrs"> -->
  <v-row style="padding:0px;" class="ma-0" :key="cmpKey">
    <common ref="common"></common>
    <v-row class="ma-0">
      <!-- <v-card> -->
        <div style="min-height: auto;">
          <h5 style="margin-left:20px;">{{ heading }}</h5>
          <v-form v-if="isPermanent" style="float:right">
            <v-checkbox
              v-model="checkBoxTicked"
              v-on:change="CheckBoxchanged($event)"
              border
              size="mini"
              >Is Same As Postal</v-checkbox
            >
          </v-form>
        </div>
        <!-- <v-card-text> -->
          <v-form>
            <v-row class="ma-0">
              <v-col cols="12" sm="6" class="py-1">
                <ValidationProvider name="Door Number" rules="required" v-slot="{errors}">
                <v-text-field
                  label="Door Number"
                  ref="doorNumber"
                  autocomplete="off"
                  v-model="addComp.doorNumber"
                  name="Door Number"
                  outlined
                  :disabled="checkBoxTicked"
                  :error-messages="errors"
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  label="Street"
                  autocomplete="off"
                  v-model="addComp.street"
                  ref="street"
                  name="Street"
                  outlined
                  :disabled="checkBoxTicked"
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  ref="place"
                  label="Place"
                  autocomplete="off"
                  v-model="addComp.place"
                  class="form-control"
                  name="Place"
                  :disabled="checkBoxTicked"
                  outlined
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1" v-if="isIndian">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  class="form-control"
                  autocomplete="off"
                  ref="pinCode"
                  v-model="addComp.pinCode"
                  v-on:blur="ShowPosts()"
                  label="Enter pinCode or choose post office"
                  name="PinCode"
                  :disabled="checkBoxTicked"
                  outlined
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col v-if="!isIndian" cols="12" sm="6" class="py-1">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  class="form-control"
                  autocomplete="off"
                  ref="pinCode"
                  v-model="addComp.pinCode"
                  label="Enter pinCode"
                  :disabled="checkBoxTicked"
                  outline
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  v-model="addComp.postOfficeName"
                  :disabled="checkBoxTicked"
                  label="Post Office"
                  dense
                  outlined
                  
                ></v-text-field>
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  label="City"
                  autocomplete="off"
                  v-model="addComp.city"
                  class="form-control"
                  :disabled="checkBoxTicked"
                  dense
                  outlined
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1" v-if="isIndian">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  label="District"
                  autocomplete="off"
                  v-model="addComp.district.name"
                  class="form-control"
                  readonly
                  outlined
                  :disabled="checkBoxTicked"
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="6" class="py-1" v-if="isIndian">
                <ValidationProvider rules="required" v-slot="{errors}">
                <v-text-field
                  :key="addComp.district.stateName"
                  label="State"
                  autocomplete="off"
                  v-model="addComp.district.stateName"
                  class="form-control"
                  outlined
                  readonly
                  :disabled="checkBoxTicked"
                  dense
                  
                />
              </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        <!-- </v-card-text> -->
      <!-- </v-card> -->
    </v-row>
    <v-dialog v-model="outerVisible" persistent open-on-focus>
      <v-card>
        <v-card-title>
          Select post office :
        </v-card-title>
        <v-card-text>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" class="py-1" v-if="outerVisible">
              <v-select
                :items="PostSelectModal"
                label="Type to search"
                item-text="name"
                item-value="id"
                dense
                outlined
                
                @change="OnPostSelectModal"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
<!-- </ValidationObserver> -->
</template>

<script>
import Vue from 'vue'
import common from '@/components/tools/common'
import VueEvents from 'vue-events'
import { callApi } from '@/api/others'
import dayjs from 'dayjs'
import { ValidationObserver, ValidationProvider } from "vee-validate";
Vue.use(VueEvents)
export default {
  props: {
    heading: String,
    addComp: Object,
    disStyle: String,
    modalid: String,
    isPermanent: Boolean,
    isIndian: Boolean,
    isEditing: {
      type: Boolean,
      default: false
    },
    hideContent: {
      type: Boolean,
      default: false
    },
    checkBoxTicked: {
      type: Boolean,
      default: false
    }
  },
  components: { common, ValidationObserver, ValidationProvider },
  data() {
    return {
      display: 'none',
      Posts: [],
      ModalPosts: [],
      PostSelect: '',
      PostSelectModal: '',
      outerVisible: false,
      cmpKey:0,
    }
  },
  watch: {
    isEditing: function(newValue) {
      if (newValue) {
        this.setPostOffice()
      }
    },
    PostSelect: function(newValue) {
      // if (newValue != null && newValue !== '') {
      //   this.addComp.postOfficeName = newValue.name
      //   this.addComp.pinCode = newValue.pinCode
      // } else {
      //   this.addComp.postOfficeName = ''
      // }
    }
  },
  mounted() {
    this.display = this.disStyle
    if (this.isEditing) {
      this.setPostOffice()
    } else {
      //   this.checkBoxTicked = true;
    }
  },
  methods: {
    clear() {
      this.addComp.id = '00000000-0000-0000-0000-000000000000'
      this.addComp.doorNumber = ''
      this.addComp.street = ''
      this.addComp.place = ''
      this.addComp.city = ''
      this.addComp.pinCode = ''
      this.addComp.postOfficeId = '00000000-0000-0000-0000-000000000000'
      this.addComp.postOfficeName = ''
      this.addComp.districtId = '00000000-0000-0000-0000-000000000000'
      this.addComp.adnl_Fld = ''
      this.addComp.actionDate = dayjs().format('YYYY/MM/DD')
      this.addComp.userId = '00000000-0000-0000-0000-000000000000'
      this.addComp.district = {
        id: '00000000-0000-0000-0000-000000000000',
        name: '',
        stateId: '00000000-0000-0000-0000-000000000000',
        stateName: '',
        activeFrom: dayjs().format('YYYY/MM/DD'),
        activeTo: dayjs().format('YYYY/MM/DD'),
        actionDate: dayjs().format('YYYY/MM/DD'),
        userId: '00000000-0000-0000-0000-000000000000',
        approvalStatus: 0
      }
      this.PostSelect = ''
      this.PostSelectModal = ''
      setTimeout(() => {
        // this.errors.clear();
      }, 50)
    },
    CollaspeCard() {
      if (this.display === 'none') {
        this.display = 'block'
      } else {
        this.display = 'none'
      }
    },
    setPostOffice() {
      var self = this
      var count = 0
      var interval = setInterval(() => {
        self.PostSelect = {
          name: self.addComp.postOfficeName,
          pinCode: self.addComp.pinCode,
          id: self.addComp.postOfficeId
        }
        count = count + 1
        if (count === 6) {
          clearInterval(interval)
        }
      }, 1000)
    },
    CheckBoxchanged(event) {
      this.$emit('CheckBoxchanged', event)
    },
    asyncFindPost: async (query) => {
      var self = this
      var common = this.$refs.common
      var url = '/api/core/postoffice/getauto?searchQuery=' + query
      callApi(url, 'get', '')
        .then((response) => {
          self.ModalPosts = response.data
        })
        .catch((error) => {
          common.ManageResponse(error.response)
        })
    },
    async OnPostSelectModal(selectedId) {
      var self = this
      self.outerVisible = false
      var selected = []
      var common = this.$refs.common
      if (this.ModalPosts.length > 0) {
        var add = this.ModalPosts.filter((x) => x.id === selectedId)[0]
        selected = add
      }
      this.addComp.pinCode = selected.pinCode
      this.addComp.postOfficeId = selected.id
      this.addComp.postOfficeName = selected.name
      var url =
        '/api/core/postoffice/getByPost?post=' +
        selected.name +
        '&pinCode=' +
        selected.pinCode

      await callApi(url, 'get', '')
        .then((response) => {
          self.addComp.district.stateName = response.data[0].state
          self.addComp.district.stateId = response.data[0].stateId
          self.addComp.district.name = response.data[0].district
          self.addComp.districtId = response.data[0].districtId
          self.addComp.city = response.data[0].taluk
          console.log("getByPost",self.addComp);
          var post = {
            id: selected.id,
            name: selected.name,
            pinCode: selected.pinCode
          }

          self.PostSelectModal = post
          self.PostSelect = post
          setTimeout(()=>{
            self.cmpKey++
          },10)
        })
        .catch((error) => {
          console.log(error)
          common.ManageResponse(error.response)
        })
    },
    async ShowPosts() {
      var self = this
      var common = this.$refs.common
      if (this.addComp.pinCode !== '' && this.addComp.pinCode != null) {
        var url =
          '/api/core/postoffice/getPostsByPin?pinCode=' + self.addComp.pinCode
        callApi(url, 'get', '')
          .then((response) => {
            if (response.data.length > 0) {
              self.ModalPosts = response.data
              self.PostSelect = self.ModalPosts[0]
              if (response.data.length === 1) {
                var post = {
                  id: response.data[0].id,
                  name: response.data[0].name,
                  pinCode: response.data[0].pinCode
                }
                self.postOfficeName = post.name
                self.OnPostSelect(post)
              } else {
                post = []
                for (var i = 0; i < response.data.length; i++) {
                  var sum = {
                    id: response.data[i].id,
                    name: response.data[i].name,
                    pinCode: response.data[i].pinCode
                  }
                  post.push(sum)
                }
                self.PostSelectModal = post
                self.outerVisible = true
                self.setPostOffice(post)
              }
            } else {
              self.addComp.pinCode = ''
              self.addComp.postOfficeId = '00000000-0000-0000-0000-000000000000'
              self.addComp.postOfficeName = ''
              self.addComp.district.stateName = ''
              self.addComp.district.stateId =
                '00000000-0000-0000-0000-000000000000'
              self.addComp.district.name = ''
              self.addComp.districtId = '00000000-0000-0000-0000-000000000000'
              self.addComp.city = ''
              self.PostSelect = ''
              self.PostSelectModal = ''
              common.showSnackBar(
                'Pin Code does not exist! Please check your Pin Code.',
                'error'
              )
            }
          })
          .catch((error) => {
            console.log(error)
            common.ManageResponse(error.response)
          })
      }
    },
    Ok() {
      // eslint-disable-next-line no-undef
      $('#' + this.modalid).modal('toggle')
    },
    hideContentClicked() {
      this.$emit('HideContentClicked')
    },
    async OnPostSelect(selected) {
      var self = this
      var common = this.$refs.common
      this.addComp.pinCode = selected.pinCode
      this.addComp.postOfficeId = selected.id
      this.addComp.postOfficeName = selected.name
      var url =
        '/api/core/postoffice/getByPost?post=' +
        selected.name +
        '&pinCode=' +
        selected.pinCode
      callApi(url, 'get', '')
        .then((response) => {
          self.addComp.district.stateName = response.data[0].state
          self.addComp.district.stateId = response.data[0].stateId
          self.addComp.district.name = response.data[0].district
          self.addComp.districtId = response.data[0].districtId
          self.addComp.city = response.data[0].taluk
          console.log("self.addComp.district",self.addComp.district);
        })
        .catch((error) => {
          console.log(error)
          common.ManageResponse(error.response)
        })
    },
    // this function is not working
    async ValidateAddress() {
      var isValid = false
      await this.$validator.validateAll().then((result) => {
        isValid = result
      })
      return isValid
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 80%;
}
.el-select option {
  width: 80%;
}
</style>
